import { createForm } from '@seek/forms-ui';

export interface FormValues {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneCountryCode: string;
}

export const { FormProvider, useField } = createForm<FormValues, any, 'en'>(
  'profileDetailsForm',
);
